// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__vu5kb","empty":"ModalGraph_empty__3WVqO"};